export default __webpack_public_path__ + "static/media/fwopening.39620397.png";